import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'

import { Box } from '@mui/material'


import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import AssignmentForm from 'components/organisms/forms/AssignmentForm'
import ConversationForm from 'components/organisms/forms/ConversationForm'
import Tabs from 'components/organisms/tabs/Tabs'

import { useHash } from 'utils/customHooks/useHash'
import { crudActionsMap } from 'utils/helpers'

import AssessForm from 'components/organisms/forms/AssessForm'
import { useGET_assignmentByIdQuery } from 'redux/api/assignmentsApi'
import AssignmentNotes from 'components/utilized/assignment/AssignmentNotes'

const AssignmentCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id

  const action = crudActionsMap[params['*']?.split('/')?.[1]]
  const viewOnly = action === 'view' || action === 'delete'

  const user = useSelector((state: RootState) => state['user'].user)


  const {hash} = useHash();

  const { data: assignment } = useGET_assignmentByIdQuery(id, { skip: !id })


  return (
    <>
      <PageHeading title={`${t('common.assignments')} / ${t('common.' + action)}`} />
      <PageBody>
        <Box sx={{ marginTop: '-1rem' }}>
          <Tabs tabKey={hash || 'info'}>
            <AssignmentForm
              tabText={`${t('assignments.assignment-information')}`}
              tabKey={'info'}
              action={action}
              assignmentId={id}
              viewOnly={viewOnly}
              userRole={user?.role}
            />

           {assignment && 
            <AssignmentNotes
              tabText={`${t('common.additional-information')}`}
              tabKey={'notes'}
              action={action}
              assignmentId={id}
              viewOnly={viewOnly}
              userRole={user?.role}
            />
            }

            {assignment && assignment.are_comments_allowed && assignment.conversation_id && 
            <ConversationForm
              tabText={`${t('common.conversation')}`}
              tabKey={'conversation'}
              action={action}
              conversationId={assignment.conversation_id.toString()}
              viewOnly={viewOnly}
            />
            }

            {assignment && assignment.status?.id !== 'draft' &&
            <AssessForm
              tabText={`${t('common.assessment')}`}
              tabKey={'assessment'}
              action={action}
              assignmentId={id}
              viewOnly={viewOnly}
              userRole={user?.role}
            />
            }
          </Tabs>
        </Box>
      </PageBody>
    </>
  )
}
export default AssignmentCrudPage

const TabPlaceHolder = ({ tabText }) => {
  return <p>{tabText}</p>
}
